/* jshint ignore:start */
/*------------------------------------
 * Theme: Plate by studio.bio
 * File: Main theme scripts file
 * Author: Joshua Michaels
 * URI: https://studio.bio/themes/plate
 *------------------------------------
 *
 * This file should contain any js scripts you want to add to the site.
 * Instead of calling it in the header or throwing it inside wp_head()
 * this file will be called automatically in the footer so as not to
 * slow the page load.
 *
 * There are a lot of example functions and tools in here. If you don't
 * need any of it, just remove it. They are meant to be helpers and are
 * not required. It's your world baby, you can do whatever you want.
 *
 * Added a few things back in from Template like the Detect User Agent
 * script and a few others that we use all the time.
*/

/*---------------------------------------
* Detect User Agent Script
* http://cssuseragent.org
*----------------------------------------
* This is by far the best detection script I've found.
* Using javascript means that this will work with caching. W00t.
*
* Adds user agent classes to the <html> element on your page including OS
* and browser version.
*
* This script has support for about every device imaginable so if you
* want to create specific styles for a symbian browser, go to town. It
* has gotten me out of a few sticky situations.
*
* Used in combination with Browserstack: https://browserstack.com/
* will keep your clients happy.
*
* If you don't need/want this, just remove it or comment it out.
*
*/

var cssua=function(n,l,p){var q=/\s*([\-\w ]+)[\s\/\:]([\d_]+\b(?:[\-\._\/]\w+)*)/,r=/([\w\-\.]+[\s\/][v]?[\d_]+\b(?:[\-\._\/]\w+)*)/g,s=/\b(?:(blackberry\w*|bb10)|(rim tablet os))(?:\/(\d+\.\d+(?:\.\w+)*))?/,t=/\bsilk-accelerated=true\b/,u=/\bfluidapp\b/,v=/(\bwindows\b|\bmacintosh\b|\blinux\b|\bunix\b)/,w=/(\bandroid\b|\bipad\b|\bipod\b|\bwindows phone\b|\bwpdesktop\b|\bxblwp7\b|\bzunewp7\b|\bwindows ce\b|\bblackberry\w*|\bbb10\b|\brim tablet os\b|\bmeego|\bwebos\b|\bpalm|\bsymbian|\bj2me\b|\bdocomo\b|\bpda\b|\bchtml\b|\bmidp\b|\bcldc\b|\w*?mobile\w*?|\w*?phone\w*?)/,
x=/(\bxbox\b|\bplaystation\b|\bnintendo\s+\w+)/,k={parse:function(b,d){var a={};d&&(a.standalone=d);b=(""+b).toLowerCase();if(!b)return a;for(var c,e,g=b.split(/[()]/),f=0,k=g.length;f<k;f++)if(f%2){var m=g[f].split(";");c=0;for(e=m.length;c<e;c++)if(q.exec(m[c])){var h=RegExp.$1.split(" ").join("_"),l=RegExp.$2;if(!a[h]||parseFloat(a[h])<parseFloat(l))a[h]=l}}else if(m=g[f].match(r))for(c=0,e=m.length;c<e;c++)h=m[c].split(/[\/\s]+/),h.length&&"mozilla"!==h[0]&&(a[h[0].split(" ").join("_")]=h.slice(1).join("-"));
w.exec(b)?(a.mobile=RegExp.$1,s.exec(b)&&(delete a[a.mobile],a.blackberry=a.version||RegExp.$3||RegExp.$2||RegExp.$1,RegExp.$1?a.mobile="blackberry":"0.0.1"===a.version&&(a.blackberry="7.1.0.0"))):x.exec(b)?(a.game=RegExp.$1,c=a.game.split(" ").join("_"),a.version&&!a[c]&&(a[c]=a.version)):v.exec(b)&&(a.desktop=RegExp.$1);a.intel_mac_os_x?(a.mac_os_x=a.intel_mac_os_x.split("_").join("."),delete a.intel_mac_os_x):a.cpu_iphone_os?(a.ios=a.cpu_iphone_os.split("_").join("."),delete a.cpu_iphone_os):a.cpu_os?
(a.ios=a.cpu_os.split("_").join("."),delete a.cpu_os):"iphone"!==a.mobile||a.ios||(a.ios="1");a.opera&&a.version?(a.opera=a.version,delete a.blackberry):t.exec(b)?a.silk_accelerated=!0:u.exec(b)&&(a.fluidapp=a.version);a.edge&&(delete a.applewebkit,delete a.safari,delete a.chrome,delete a.android);if(a.applewebkit)a.webkit=a.applewebkit,delete a.applewebkit,a.opr&&(a.opera=a.opr,delete a.opr,delete a.chrome),a.safari&&(a.chrome||a.crios||a.fxios||a.opera||a.silk||a.fluidapp||a.phantomjs||a.mobile&&
!a.ios?(delete a.safari,a.vivaldi&&delete a.chrome):a.safari=a.version&&!a.rim_tablet_os?a.version:{419:"2.0.4",417:"2.0.3",416:"2.0.2",412:"2.0",312:"1.3",125:"1.2",85:"1.0"}[parseInt(a.safari,10)]||a.safari);else if(a.msie||a.trident)if(a.opera||(a.ie=a.msie||a.rv),delete a.msie,delete a.android,a.windows_phone_os)a.windows_phone=a.windows_phone_os,delete a.windows_phone_os;else{if("wpdesktop"===a.mobile||"xblwp7"===a.mobile||"zunewp7"===a.mobile)a.mobile="windows desktop",a.windows_phone=9>+a.ie?
"7.0":10>+a.ie?"7.5":"8.0",delete a.windows_nt}else if(a.gecko||a.firefox)a.gecko=a.rv;a.rv&&delete a.rv;a.version&&delete a.version;return a},format:function(b){var d="",a;for(a in b)if(a&&b.hasOwnProperty(a)){var c=a,e=b[a],c=c.split(".").join("-"),g=" ua-"+c;if("string"===typeof e){for(var e=e.split(" ").join("_").split(".").join("-"),f=e.indexOf("-");0<f;)g+=" ua-"+c+"-"+e.substring(0,f),f=e.indexOf("-",f+1);g+=" ua-"+c+"-"+e}d+=g}return d},encode:function(b){var d="",a;for(a in b)a&&b.hasOwnProperty(a)&&
(d&&(d+="\x26"),d+=encodeURIComponent(a)+"\x3d"+encodeURIComponent(b[a]));return d}};k.userAgent=k.ua=k.parse(l,p);l=k.format(k.ua)+" js";n.className=n.className?n.className.replace(/\bno-js\b/g,"")+l:l.substr(1);return k}(document.documentElement,navigator.userAgent,navigator.standalone);


/*
 * Get Viewport Dimensions
 * returns object with viewport dimensions to match css in width and height properties
 * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
*/
function updateViewportDimensions() {
	var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
	return { width:x,height:y };
}
// setting the viewport width
var viewport = updateViewportDimensions();


/*
 * Throttle Resize-triggered Events
 * Wrap your actions in this function to throttle the frequency of firing them off, for better performance, esp. on mobile.
 * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
*/
var waitForFinalEvent = (function () {
	var timers = {};
	return function (callback, ms, uniqueId) {
		if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
		if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 100;


/*
 * Here's an example so you can see how we're using the above function
 *
 * This is commented out so it won't work, but you can copy it and
 * remove the comments.
 *
 *
 *
 * If we want to only do it on a certain page, we can setup checks so we do it
 * as efficient as possible.
 *
 * if( typeof is_home === "undefined" ) var is_home = $('body').hasClass('home');
 *
 * This once checks to see if you're on the home page based on the body class
 * We can then use that check to perform actions on the home page only
 *
 * When the window is resized, we perform this function
 * $(window).resize(function () {
 *
 *    // if we're on the home page, we wait the set amount (in function above) then fire the function
 *    if( is_home ) { waitForFinalEvent( function() {
 *
 *	// update the viewport, in case the window size has changed
 *	viewport = updateViewportDimensions();
 *
 *      // if we're above or equal to 768 fire this off
 *      if( viewport.width >= 768 ) {
 *        console.log('On home page and window sized to 768 width or more.');
 *      } else {
 *        // otherwise, let's do this instead
 *        console.log('Not on home page, or window sized to less than 768.');
 *      }
 *
 *    }, timeToWaitForLast, "your-function-identifier-string"); }
 * });
 *
 * Pretty cool huh? You can create functions like this to conditionally load
 * content and other stuff dependent on the viewport.
 * Remember that mobile devices and javascript aren't the best of friends.
 * Keep it light and always make sure the larger viewports are doing the heavy lifting.
 *
*/

/*
 * We're going to swap out the gravatars.
 * In the functions.php file, you can see we're not loading the gravatar
 * images on mobile to save bandwidth. Once we hit an acceptable viewport
 * then we can swap out those images since they are located in a data attribute.
*/
function loadGravatars() {
    // set the viewport using the function above
    viewport = updateViewportDimensions();
    // if the viewport is tablet or larger, we load in the gravatars
    if (viewport.width >= 768) {
        jQuery('.comment img[data-gravatar]').each(function(){
            jQuery(this).attr('src',jQuery(this).attr('data-gravatar'));
        });
    }
} // end function

/* jshint ignore:end */

function slugify(text) {
  return text
    .toString()                     // Cast to string
    .toLowerCase()                  // Convert the string to lowercase letters
    .normalize('NFD')               // The normalize() method returns the Unicode Normalization Form of a given string.
    .trim()                         // Remove whitespace from both sides of a string
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-');        // Replace multiple - with single -
}

function setupTogglers(){
    let debug = false;
    if(debug && window.console){console.log('setupTogglers()');}
    var $togglers = jQuery('[data-toggle-target][data-toggle-classes],[data-toggle-closest-target][data-toggle-classes]');
    $togglers.each(function(){
        var $toggler = jQuery(this);
        var $target = ($toggler.is('[data-toggle-closest-target]')) ? $toggler.closest($toggler.attr('data-toggle-closest-target')) : jQuery($toggler.attr('data-toggle-target'));
        var sClasses = $toggler.attr('data-toggle-classes');
        if(debug && window.console){
            console.log('$toggler',$toggler);
            console.log('$target',$target);
            console.log('sClasses',sClasses);
        }
        $toggler.on('click',function(e){
            if(debug && window.console){console.log('toggler click!');}
            if($toggler.is('a')){
                e.preventDefault();
            }
            if($target && $target.length){
                $target.toggleClass(sClasses);
            }
            if($toggler.is('[data-toggle-self-classes]')){
                var sSelfClasses = $toggler.attr('data-toggle-self-classes');
                $toggler.toggleClass(sSelfClasses);
            }
            if($toggler.is('[data-focus-target')){
                var sFocusTargetSelector = $toggler.attr('data-focus-target');
                var $focusTaget = $target.find(sFocusTargetSelector).trigger('focus');

            }
        });
    });
}


// for detecting when to change the mobile menu toggler style
function deskHeaderIntersectionCallback(entries, observer) {
    let debug = false;
    if(debug && window.console){
        console.log('deskHeaderIntersectionCallback()');
    }
    var $h = jQuery('body.is-home #header');
    // var $toggler = jQuery('.menu-ctrl-container.mq-mobileonly');

    if (entries[0].boundingClientRect.y > -2) {
        $h.removeClass("desk-header-not-at-top");
        if(debug && window.console){
            console.log('header-at-top');
        }
    } else {
        $h.addClass("desk-header-not-at-top");
        if(debug && window.console){
            console.log('header-NOT-at-top');
        }
    }
    if(debug && window.console){
        console.log('entries[0].boundingClientRect.y',entries[0].boundingClientRect.y);
    }
}
function setupDeskHeaderIntersectionObservers(){
    let debug = false;
    if(debug && window.console){
        console.log('setupDeskHeaderIntersectionObservers()');
    }
    if(!window.IntersectionObserver){
        if(debug && window.console){
            console.log('cancel setup of IntersectionObserver');
        }
        return;
    }
    var $positioningPixel = jQuery('.js-top-of-site-anchor');
    var deskHeaderIntersectionOptions = {};//{rootMargin: sBottomMargin };
    var deskHeaderInterectionObserver = new IntersectionObserver(deskHeaderIntersectionCallback, deskHeaderIntersectionOptions);
    deskHeaderInterectionObserver.observe($positioningPixel.get(0));
}
function setupDesktopNavEnhancement(){
    let debug = false;
    if(debug && window.console){console.log('setupDesktopNavEnhancement()');}
    // add desktop search toggle
    jQuery('#menu-main-menu').append('<li class="mq-desktoponly"><a href="#search" data-toggle-target="#header" data-toggle-classes="desktop-search-closed desktop-search-open" data-focus-target="input[name=s]"><span class="reader-txt-label">Open/close Search</span><i class="far fa-search"></i></a></li>');

    // add desktop nav scrunchin
    // setupDeskHeaderIntersectionObservers();
}

function addFooterIcons(){
    let debug = false;
    if(debug && window.console){console.log('addFooterIcons()');}
    var $footerLinksNeedingIcons = jQuery('#footer li[class*="add-icon-"]');
    $footerLinksNeedingIcons.each(function(){
        var $li = jQuery(this);
        var $a = $li.find('a').first();
        if($li.is('.add-icon-linkedin')){
            $a.prepend('<span class="icon-container"><i class="fab fa-linkedin-in fa-fw"></i></span>');
        }
        if($li.is('.add-icon-email')){
            $a.prepend('<span class="icon-container"><i class="fas fa-envelope fa-fw"></i></span>');
        }
        if($li.is('.add-icon-tel')){
            $a.prepend('<span class="icon-container"><i class="fas fa-phone-alt fa-fw"></i></span>');
        }
    });
    if(debug && window.console){
        console.log('$footerLinksNeedingIcons',$footerLinksNeedingIcons);
    }
}

function scrollToTarget($target){
    var $header = jQuery('#header');
    var bHeaderIsSticky = $header.css('position') && $header.css('position') === 'fixed';
    var bAdminBarVisible = (jQuery('#wpadminbar').length > 0) ? true : false;
    var nHeaderOffset = (bHeaderIsSticky) ? $header.outerHeight() : 0;
    var nTopOffset = 10; // just in case we dont want the target flush top
    nHeaderOffset += nTopOffset;
    if(bAdminBarVisible){
        nHeaderOffset += jQuery('#wpadminbar').outerHeight();
    }
    jQuery('html, body').animate({
        scrollTop: $target.offset().top - nHeaderOffset
    });
}

function setupSmoothAnchorScrollers($){
    // https://css-tricks.com/snippets/jquery/smooth-scrolling/
    // modified for sticky headahs
    let debug = false;
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
        // On-page links
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            var $header = $('#header');
            var bHeaderIsSticky = $header.css('position') && $header.css('position') === 'fixed';
            var bAdminBarVisible = ($('#wpadminbar').length > 0) ? true : false;
            var nHeaderOffset = (bHeaderIsSticky) ? $header.outerHeight() : 0;
            var nTopOffset = 10; // just in case we dont want the target flush top
            nHeaderOffset += nTopOffset;
            if(bAdminBarVisible){
                nHeaderOffset += $('#wpadminbar').outerHeight();
            }
            if(debug && window.console){
                console.log('bAdminBarVisible',bAdminBarVisible);
                console.log('bHeaderIsSticky',bHeaderIsSticky);
                console.log('nHeaderOffset',nHeaderOffset);
            }
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            target = target.length ? target : $('[id=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                event.preventDefault();

                $('html, body').animate({
                  scrollTop: target.offset().top - nHeaderOffset
                }, 1000, function() {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    /*
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    }
                    */
                });
            }
        }
    });
}


// for detecting when to change the mobile menu toggler style
function headerIntersectionCallback(entries, observer) {
  let debug = true;
  // var $h = jQuery('#header');
  var $toggler = jQuery('.menu-ctrl-container.mq-mobileonly');
  for (var i = 0; i < entries.length; i++) {
    var entry = entries[i];
    var entryId = entry.target.id; // which could be emptry string/undefined
    if (entry.isIntersecting) {
      if(debug && window.console){console.log('INTERSECTING!', entry.target);}
      if(debug && window.console){console.log(entry);}
      $toggler.removeClass('circle');
      // $h.attr('data-inverted-by',entryId);
    } else {
      if(debug && window.console){console.log('NOT INTERSECTING!', entry.target);}
      if(debug && window.console){console.log(entry);}
      $toggler.addClass('circle');
      // if($h.attr('data-inverted-by') === entryId){
      //   $h.removeClass('invert');
      // }
    }
  }
}
function setupHeaderIntersectionObservers(){
    let debug = false;
    if(debug && window.console){
        console.log('setupHeaderIntersectionObservers()');
    }
    if(!window.IntersectionObserver){
        if(debug && window.console){
            console.log('cancel setup of IntersectionObserver');
        }
        return;
    }
    var $mobileMenuToggle = jQuery('.menu-ctrl-container.mq-mobileonly');
    var $header = jQuery('#header');

    if(!$mobileMenuToggle.is(':visible')){
        if(debug && window.console){console.log('mobile toggler not visible so not gonna setup its intersection observer');}
        if(debug && window.console){
            console.log('canceling an IntersectionObserver because its not supported');
        }
        return false;
    }

    var nViewportHeight = jQuery(window).height();
    var nHeaderHeight = jQuery('#header').height();
    var nBottomMargin = nViewportHeight - nHeaderHeight; // classic
    // var nBottomMargin = nViewportHeight - (nHeaderHeight / 2); // KP suggested
    // var nBottomMargin = nViewportHeight - (nHeaderHeight - 6); // Make hit area slightly larger for more responsive feel
    var sBottomMargin = '0px 0px -'+nBottomMargin+'px 0px';
    if(debug && window.console){
      console.log('nViewportHeight',nViewportHeight);
      console.log('nHeaderHeight',nHeaderHeight);
      console.log('sBottomMargin',sBottomMargin);
    }
    var headerIntersectionOptions = {
      rootMargin: sBottomMargin
    };

    // the instersection watcher
    var headerInterectionObserver = new IntersectionObserver(headerIntersectionCallback, headerIntersectionOptions);
    headerInterectionObserver.observe($header.get(0));

    // $sections is the collection of elements that I want to be watched for instesections with the nav
    // var $sections = $mobileMenuToggle;
    // $sections.each(function(){
    //   var $s = jQuery(this);
    //   var oEle = $s[0]; // faster than get(0) I read
    //   headerInterectionObserver.observe(oEle);
    // });
}

function setupMobileNavEnhancement(){
    setupHeaderIntersectionObservers();
}

function setupScrollInAnimations($){
    var debug = false;
    if(debug && window.console){
        console.log('setupScrollInAnimations()',setupScrollInAnimations);
        console.log('viewport',viewport);
    }

    if(viewport && (viewport.width < 768)){
        if(debug && window.console){
            console.log('lets not do the animations on your small device');
        }
        return;
    }

    $('.large-col .provider-app .links').attr('data-scrollin-style','fadeInFromLeft');
    $('.large-col .member-app .links').attr('data-scrollin-style','fadeInFromRight');


    gsap.registerPlugin(ScrollTrigger);
    var $scrollIns = $('[data-scrollin-style]');
    $scrollIns.each(function(){
        var $scrollInEle = $(this);
        var sScrollInEffect = $scrollInEle.attr('data-scrollin-style');
        var oFrom = {};
        var oTo = {};

        switch(sScrollInEffect){
            case 'fadeInFromBelow':
                oFrom = {
                    opacity: 0.25,
                    y: '+=35px'
                };
                oTo = {
                    opacity: 1,
                    y: 0,
                    scrollTrigger: {
                        trigger: $scrollInEle,
                        duration: 300,
                        start: '30% bottom',
                        end: 200,
                        scrub: true
                    }
                };
                break;
            case 'slideInFromBelow':
                oFrom = {
                    y: '+=35px'
                };
                oTo = {
                    y: 0,
                    scrollTrigger: {
                        trigger: $scrollInEle,
                        duration: 300,
                        start: '15% bottom',
                        end: 200,
                        scrub: true
                    }
                };
                break;
            case 'fadeInFromLeft':
                oFrom = {
                    opacity: 0.25,
                    x: '-=35px'
                };
                oTo = {
                    opacity: 1,
                    x: 0,
                    scrollTrigger: {
                        trigger: $scrollInEle,
                        duration: 300,
                        start: '25% bottom',
                        end: 200,
                        toggleActions: 'play none none reset',
                        scrub: false
                    }
                };
                break;
            case 'slideInFromLeft':
                oFrom = {
                    x: '-=35px'
                };
                oTo = {
                    x: 0,
                    scrollTrigger: {
                        trigger: $scrollInEle,
                        duration: 300,
                        start: '15% bottom',
                        end: 200,
                        toggleActions: 'play none none reset',
                        scrub: false
                    }
                };
                break;
            case 'fadeInFromRight':
                oFrom = {
                    opacity: 0.25,
                    x: '+=35px'
                };
                oTo = {
                    opacity: 1,
                    x: 0,
                    scrollTrigger: {
                        trigger: $scrollInEle,
                        start: '25% bottom',
                        end: 200,
                        toggleActions: 'play none none reset',
                        scrub: false
                    }
                };
                break;
            case 'slideInFromRight':
                oFrom = {
                    x: '+=35px'
                };
                oTo = {
                    x: 0,
                    scrollTrigger: {
                        trigger: $scrollInEle,
                        start: '15% bottom',
                        end: 200,
                        toggleActions: 'play none none reset',
                        scrub: false
                    }
                };
                break;
            case 'fadeIn':
                oFrom = {
                    opacity: 0.25
                };
                oTo = {
                    opacity: 1,
                    scrollTrigger:{
                        trigger: $scrollInEle,
                        start: '25% bottom',
                        end: 200,
                        scrub: false
                    }
                };
                break;
            default:
                break;
        }

        if(debug && window.console){
            console.log('$scrollInEle',$scrollInEle);
            console.log('sScrollInEffect',sScrollInEffect);
        }
        // gsap.set($scrollInEle,{opacity:0});
        gsap.fromTo($scrollInEle,oFrom,oTo);
    });

    var $postOrCardList = $('.cards-list .card,.post-list article,.nb-posts .nb-post');
    gsap.set($postOrCardList, {y: 40,opacity:0.25});
    // gsap.set($postOrCardList, {y: 40});
    ScrollTrigger.batch($postOrCardList, {
      interval: 0.1, // time window (in seconds) for batching to occur.
      batchMax: 3,   // maximum batch size (targets). Can be function-based for dynamic values
      // onEnter: batch => gsap.to(batch, {y: 0, stagger: {each: 0.15}, overwrite: true}),
      onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
      // onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
      // onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
      // onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true}),
      // you can also define most normal ScrollTrigger values like start, end, etc.
      start: "20px bottom",
      end: "bottom top"
    });

    ScrollTrigger.addEventListener("refreshInit", () => gsap.set($postOrCardList, {y: 0,opacity:1}));
}

function setupTestimonialSliders($){
    if($('html').is('[class*=trident]')){
        if(window.console){
            console.log('testimonial-slider does not support IE');
        }
        $('.section-testimonials').remove();
        return;
    }
    var $testimonialSection = jQuery('.section-testimonials');
    if($testimonialSection.is('.t-0,.t-1')){
        if(window.console){
            console.log('testimonial-slider has only one slide');
        }
        return;
    }

    var mySwiper = new Swiper('.testimonial-slides.swiper-container', {
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
}

function setupClipboardCopiers(){
    // console.log('setupClipboardCopiers()');
    var cb = new ClipboardJS('.clipboard-copy');
    cb.on('success', function(e) {
        // console.info('Action:', e.action);
        // console.info('Text:', e.text);
        // console.info('Trigger:', e.trigger);

        e.clearSelection();
    });
    cb.on('error', function(e) {
        if(window.console){
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        }
    });
}

function addClassToCategoryLinks(){
    var $catLinks = jQuery('a[rel="category tag"]');
    $catLinks.each(function() {
        var $catLink = jQuery(this);
        var sInnerText = $catLink.text();
        var sInnerTextSlug = slugify(sInnerText);
        $catLink.addClass('cat-'+sInnerTextSlug);
    });
}

function setupModalContactForm(){
    var $contactTrigger = jQuery('#menu-main-menu .toggle-forms a,a.open-contact-form');
    var $body = jQuery('body');
    var $modalCloser = jQuery('.modal-close');
    if($body.is('.page-contact-us')){
        $contactTrigger.on('click',function(event){
            event.preventDefault();
            var $firstVisibleField = jQuery('#main input:visible').first();
            var sFirstVisibleFieldId = $firstVisibleField.attr('id');
            var $firstVisibleFieldLabel = jQuery('label[for='+sFirstVisibleFieldId+']');
            scrollToTarget($firstVisibleFieldLabel);
            $firstVisibleField.focus();
        });
    } else {
        $modalCloser.on('click',function(){
            $body.removeClass('contact-modal-open').addClass('contact-modal-closed');
        });
        $contactTrigger.on('click',function(event){
            event.preventDefault();
            $body.removeClass('contact-modal-closed').addClass('contact-modal-open');
            // var $firstVisibleField = jQuery('#main input:visible').first();
            // $firstVisibleField.focus();
        });
    }
}

function makeCTAButtonsGreenInMemberApp(){
    var $body = jQuery('body');
    if($body.is('.page-member-app')){
        var $orangeButtons = jQuery('a.orange-button');
        $orangeButtons.each(function(){
            jQuery(this).removeClass('orange-button').addClass('green-button');
        });
    }
}

function addButtonIcons(){
    var $externalOrangeButtons = jQuery('a.orange-button[target="_blank"]');
    $externalOrangeButtons.each(function(){
        var $b = jQuery(this);
        $b.append('<i class="far fa-external-link-alt"></i>');
    });
}

function wrapThingsToAvoidWrap(){
    var $nwcfs = jQuery('.js-nowrap-co-founder');
    $nwcfs.each(function(){
        var $nwcf = jQuery(this);
        var sReplacementText = $nwcf.text().replace('Co-Founder','<span class="nowrap">Co-Founder</span>');
        $nwcf.html(sReplacementText);
    });
}

function bodyTopSpacerFix(){
    var $h = jQuery('#header');
    var $b = jQuery('body');
    var nHHeight = Math.floor($h.outerHeight());
    if(nHHeight && viewport && (viewport.width > 768)){
        $b.css('padding-top',nHHeight);
        // if(window.console){
        //     console.log('body padding-top set to',nHHeight);
        // }
    }
}

function domModifiers(){
    wrapThingsToAvoidWrap();
    bodyTopSpacerFix();
}

jQuery(document).ready(function($) {

    if(window.console){console.log('ready');}

    // loadGravatars();
    makeCTAButtonsGreenInMemberApp();
    setupDesktopNavEnhancement();
    setupMobileNavEnhancement();
    setupModalContactForm();
    setupTogglers();
    addButtonIcons();
    domModifiers();
    addFooterIcons();
    addClassToCategoryLinks();
    setupSmoothAnchorScrollers($);
    setupScrollInAnimations($);
    setupTestimonialSliders($);
    setupClipboardCopiers();

    // viewport = updateViewportDimensions();

    // if (viewport.width >= 768) {

    // }

    // remove <p> tags around images everywhere
    // $('p > img').unwrap();

}); /* end of as page load scripts */
